import React, { Component } from "react";

//Import CSS
import "./inputs.css";

//Import internal components
import AppContext from "../../appContext";

//Import external components
import { FormControl, InputLabel, Select, MenuItem, FormHelperText } from "@material-ui/core";

class TrackingLabChoose extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lab: [],
      labs: [],
    };
    TrackingLabChoose.contextType = AppContext;
    this.handleChange = this.handleChange.bind(this);
    this.changeComboLabUser = this.changeComboLabUser.bind(this);
  }

  componentDidMount() {
    if (this.props.labs.length === 0) {
      this.context.showLoading("Carregando...");
      let labsa = [];
      const requestOptions = {
        method: "POST",
        body: JSON.stringify({
          cnpjs: this.context.userSession.laboratorios,
          papel: this.context.userSession.papel,
          conta: this.context.userSession.conta,
        }),
      };

      fetch(process.env.REACT_APP_LABS_API + "get_labs.php", requestOptions)
        .then(response => {
          return response.json();
        })
        .then(json => {
          if (json.items) {
            for (var i = 0; i < json.items.length; i++) {
              if (json.items[i].Financeiro_c === true) {
                var pushObj = {
                  label: json.items[i].Nome_c,
                  value: json.items[i].CNPJ_c,
                  detailOrder: json.items[i].DetalhesDoPedido_c,
                  novosFiltrosFinanceiros: json.items[i].NovosFiltrosFinanceiros_c,
                  downloadNfs: json.items[i].DownloadNFs_c === true,
                  phone: json.items[i].Telefone_c,
                  logo: json.items[i].URL_Logo_c,
                  email: json.items[i].Email_c,
                  site: json.items[i].Site_c,
                };
                labsa.push(pushObj);
              }
            }
          }
          if (labsa.length === 1) {
            this.setLab({ nome: labsa[0].nome, cnpj: labsa[0].cnpj }, this.context.hideLoading);
          }

          this.setState({ labs: labsa }, this.context.hideLoading);
          this.props.handleChangeProps(labsa,'laboratorios');
          if (this.context.userSession.conta !== "" && this.context.userSession.papelCategoria === "LABORATORIO") {
            this.changeComboLabUser({ value: this.context.userSession.conta });
          }
        });
    }
    else {
      this.setState({labs:this.props.labs}, () => {
        if (this.props.lab) {
          const selectedLab = this.props.labs.find(item => item.value === this.props.lab);
          if (selectedLab) {
            var params = null;
            if (selectedLab.phone || selectedLab.email || selectedLab.site || selectedLab.logo) {
              params = {
                phone: selectedLab.phone,
                logo: selectedLab.logo,
                email: selectedLab.email,
                site: selectedLab.site,
              };
            }
            this.props.onChange(
              { name: "lab", value: selectedLab.value },
              selectedLab.label,
              selectedLab.detailOrder,
              params,
              selectedLab.novosFiltrosFinanceiros
            );
          }
        }
      });
    }
  }

  changeComboLabUser(e) {
    var label = "";
    var detail = false;
    var params = null;
    var novosFiltrosFinanceiros = false;

    this.state.labs.find((item) => {
      if (item.value === this.context.userSession.conta) {
        detail = item.detailOrder;
        label = item.label;
        novosFiltrosFinanceiros = item.novosFiltrosFinanceiros;
        if (item.phone || item.email || item.site || item.logo) {
          params = {
            phone: item.phone,
            logo: item.logo,
            email: item.email,
            site: item.site,
          };
        }
      }
    });

    this.props.onChange(
      { name: "lab", value: e.value || this.context.userSession.conta },
      label,
      detail,
      params,
      novosFiltrosFinanceiros
    );
    this.context.hideLoading();
  }

  handleChange(e) {
    var selectedValue = e.target.value;
    var label = "";
    var detail = false;
    var params = null;
    var novosFiltrosFinanceiros = false;

    if (selectedValue) {
      this.state.labs.find((item) => {
        if (item.value === selectedValue) {
          detail = item.detailOrder;
          label = item.label;
          novosFiltrosFinanceiros = item.novosFiltrosFinanceiros;
          if (item.phone || item.email || item.site || item.logo) {
            params = {
              phone: item.phone,
              logo: item.logo,
              email: item.email,
              site: item.site,
            };
          }
        }
      });
    }
    this.props.onChange(
      { name: "lab", value: selectedValue },
      label,
      detail,
      params,
      novosFiltrosFinanceiros
    );
  }

  setLab(e) {
    this.props.onChange(e);
  }

  render() {
    const isLaboratorio = this.context.userSession.papelCategoria === "LABORATORIO";
    return (
      <FormControl variant="outlined" className="lp-field" error={!!this.props.error}>
        <InputLabel id="label-lab">Escolha o laboratório *</InputLabel>
        <Select
          labelId="label-lab"
          id="lab"
          name="lab"
          value={this.props.lab || ""}
          onChange={this.handleChange}
          label="Escolha o laboratório *"
          disabled={isLaboratorio}
        >
          {this.state.labs.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
        </Select>
        {this.props.error && <FormHelperText>{this.props.error}</FormHelperText>}
      </FormControl>
    );
  }
}

export default TrackingLabChoose;
